export default function (url = ''): string {
  return (process.env.VUE_APP_BASE_URL || '') + url
}
